
const firebaseConfig = {
  apiKey: "AIzaSyBKdwHccnTqo_SDJi2jJ1YPyZoYhRVKl5U",
  authDomain: "tesla-pharmacy.firebaseapp.com",
  projectId: "tesla-pharmacy",
  storageBucket: "tesla-pharmacy.appspot.com",
  messagingSenderId: "312107960717",
  appId: "1:312107960717:web:9807cac8a6617b174fd5c4"
};

export default firebaseConfig;